import { createVNode, render } from 'vue';
import BpNotify from './BpNotify.vue';
import './notifyStack.css';

const POSICOES = [
  'top-center',
  'top-right',
  'top-left',
  'bottom-center',
  'bottom-right',
  'bottom-left',
];

const PADRAO = { color: 'primary', position: 'top-center', time: 3000 };

const pilhas = new Map();
const ativos = new Set();

function pilhaDe(position) {
  if (pilhas.has(position)) return pilhas.get(position);

  const el = document.createElement('div');
  el.className = `bp-notify-stack z-bp-notify bp-notify-stack--${position}`;
  document.body.appendChild(el);
  pilhas.set(position, el);
  return el;
}

const FOLGA_SAIDA_MS = 50;

function remover(entrada) {
  if (!ativos.has(entrada)) return;

  ativos.delete(entrada);
  clearTimeout(entrada.timer);

  let desmontado = false;
  const desmontar = () => {
    if (desmontado) return;
    desmontado = true;
    render(null, entrada.host);
    entrada.host.remove();
  };

  entrada.host.classList.add('bp-notify-stack__item--saindo');
  entrada.host.addEventListener('animationend', desmontar, { once: true });

  const bruto = getComputedStyle(entrada.host).animationDuration || '0s';
  const maxSecs = Math.max(0, ...bruto.split(',').map(s => parseFloat(s) || 0));
  const duracaoMs = maxSecs * (bruto.includes('ms') ? 1 : 1000);

  setTimeout(desmontar, duracaoMs + FOLGA_SAIDA_MS);
}

function notify(opcoes = {}) {
  const o = opcoes || {};
  const position = POSICOES.includes(o.position)
    ? o.position
    : PADRAO.position;
  const time = Number.isFinite(Number(o.time))
    ? Number(o.time)
    : PADRAO.time;

  const host = document.createElement('div');
  host.className = 'bp-notify-stack__item';
  pilhaDe(position).appendChild(host);

  const entrada = { host, timer: null };

  render(
    createVNode(BpNotify, {
      title: o.title || '',
      text: o.text || '',
      color: o.color || PADRAO.color,
      closable: true,
      onClose: () => remover(entrada),
    }),
    host,
  );

  ativos.add(entrada);

  if (time > 0) entrada.timer = setTimeout(() => remover(entrada), time);

  return () => remover(entrada);
}

notify.close = () => {
  Array.from(ativos).forEach(remover);
};

export default notify;

export const BpNotifyPlugin = {
  install(app) {
    app.config.globalProperties.$bpNotify = notify;
  },
};
